'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');

const bounce = styled.keyframes`
0% {
  transform: scale(1);
}

33% {    
  transform: scale(0.75);
}

66% {    
  transform: scale(1.25);
}

100% {
  transform: scale(1);
}
`;

exports.bounce = bounce;
//# sourceMappingURL=animations.js.map
